import { render, staticRenderFns } from "./DashboardStatsCard.vue?vue&type=template&id=46e8fa7d&scoped=true&"
import script from "./DashboardStatsCard.vue?vue&type=script&lang=js&"
export * from "./DashboardStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStatsCard.vue?vue&type=style&index=0&id=46e8fa7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e8fa7d",
  null
  
)

export default component.exports